import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import _ from 'lodash';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import FormLabel from "@material-ui/core/FormLabel";
import moment from "moment";
import FundAttachments from "../FundAttachments";
import FundNotes from "../FundNotes";
import styled from "styled-components";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import ListWrapper from "components/Global/List/Wrapper";
import FundModal from "components/Portfolio/FundModal"
import { updateFund, fetchFunds } from "store/state/fund";
import WhatIfModal from "components/Portfolio/WhatIfModal"

const TabWrapperWithBorder = styled.div`
  border-bottom: 1px solid #009DDF;
  margin-left: 56px;
  max-width: 1808px;
`;

const styles = theme => ({
  root: {
    width: "100%",
  },
  tabs: {
    fontWeight: 400,
    borderBottom: "none",
    textTransform: "capitalize",
    minWidth: 100,
    color: "#009DDF",
    width: "99%"
  },
  labelSelected: {
    fontWeight: "bold",
    borderBottom: "none",
    "vertical-align": "super",
    color: "#009DDF",
    whiteSpace:"pre-wrap"
  },
  labelUnSelected: {
    cursor: "pointer",
    whiteSpace:"pre-wrap"
  },
  tabsRoot: {
    marginTop: 10,
    fontWeight: 400,
    borderBottom: "none",
    textTransform: "capitalize",
    minWidth: 100
  },
  tabSelected: {
    fontWeight: "bold",
  }
});

const MaxHeightDiv = styled.div`
  max-height: 5px;
`;

const emptyFund = {
  name: "",
  description: "",
  inceptionDate: ""
}

class ScrollableTabButtons extends React.Component {
  state = {
    isWhatIfModalOpen: false,
    value: parseInt(this.props.fundId),
    selectedFundId: parseInt(this.props.fundId),
    isAttachmentsOpen: false,
    isNotesOpen: false,
    isNewFundModalOpen: false,
    isFundModalEdit: false,
    initialFundValues: {
      name: "",
      description: "",
      inceptionDate: ""
    },
    fundOptions: [
      {
        id: 1,
        value: "Edit Group",
        onClick: () => {          
          this.fundModalEdit(this.state.selectedFundId);
        },
        includeOnScreens: []
      },
      {
        id: 2,
        isHR: true
      },
      {
        id: 3,
        value: "Notes",
        onClick: optionId => {
          this.openNotes();
        },
        includeOnScreens: []
      },
      {
        id: 4,
        value: "Attachments",
        onClick: optionId => {
          this.openAttachments();
        },
        includeOnScreens: []
      }
    ],
    pageOptions: [
      {
        id: 1,
        value: "Add Group",
        onClick: optionId => {
          this.openFund();
        },
        includeOnScreens: []
      }
    ]
  };

  openNotes = () => {
    this.setState({ isNotesOpen: true });
  };

  closeNotes = () => {
    this.setState({ isNotesOpen: false });
  };

  openAttachments = () => {
    this.setState({ isAttachmentsOpen: true });
  };

  closeAttachments = () => {
    this.setState({ isAttachmentsOpen: false });
  };

  handleChange = (event, value) => {    
    this.setState({ value, selectedFundId: value });
    this.props.onChange(event, value);
  };

  onOpenFundModal = () => {
    this.setState({
      currentFundId: undefined,
      initialFundValues: emptyFund,
      isFundModalEdit: false,
      isNewFundModalOpen: true,
    });
  };

  onOpenWhatIfModal = () => {
    this.setState({
      isWhatIfModalOpen: true,
    });
  };

  closeWhatIfModal = () => {
    this.setState({
      isWhatIfModalOpen: false,
    })
  }

  closeFundModal = () => {
    this.setState({
      isNewFundModalOpen: false,
    });
  };

  fundModalEdit = fundId => {
    this.setState({
      isNewFundModalOpen: true,
      isFundModalEdit: true,
      currentFundId: fundId,
    });
  };

  updateInitialFundValues = funds => {
    this.setState({
      initialFundValues: _.find(funds, {id: this.state.currentFundId})
    });
  };



  updateFund = values => {
    this.props.updateFund({
      ...values
    });
  };

  menu(item, fundId) {
    const { fundOptions } = this.state;
    const { classes } = this.props;
    const isActive = item.id && item.id.toString() === fundId;
    const className = isActive
      ? classes.labelSelected
      : classes.labelUnSelected;
    return (
      <Fragment>
        {!isActive || <OptionsMenu options={fundOptions} maxHeight={400} />}
        <FormLabel className={className}>{item.name}</FormLabel>
      </Fragment>
    );
  }
  render() {
    const { classes, funds, fundId, allFunds, onAdd } = this.props;
    const {
      value,
      isAttachmentsOpen,
      isNotesOpen,
      selectedFundId,
      pageOptions,
      isNewFundModalOpen,
      isFundModalEdit,
    } = this.state;

    if (this.state.initialFundValues !== _.find(funds, {id: this.state.currentFundId})) {
      this.updateInitialFundValues(funds)
    }
    
    let fundNameList = [];
    for(const key in allFunds) {
      fundNameList.push((allFunds[key].name).toLowerCase());
    }

    return (
      <div className={classes.root}>
        <AppBar
          position="static"
          style={{
            backgroundColor: "#fff",
            color: "#606061",
            boxShadow: "none"
          }}
        >
        <MaxHeightDiv>
          <ListWrapper
            // buttonPropsLeft={{
            //   onClick: this.onOpenWhatIfModal,
            //   label: "What If",
            //   style: {
            //     top: '-34px',
            //     right: '8px'
            //   }
            // }}
            buttonProps={{
              onClick: this.onOpenFundModal,
              label: "New Group",
              style: {
                top: '-34px',
                right: '8px'
              }
            }}
            >
          </ListWrapper>
          </MaxHeightDiv>
          <Grid container spacing={8} alignItems="center">
            <Grid item xs={12}>
              <div
                className="headerItems"
                style={{ marginTop: "15px", textTransform: "uppercase" }}
              />
              <Tabs
                value={value}
                onChange={this.handleChange}
                indicatorColor="primary"
                textColor="primary"
                scrollable
                scrollButtons="auto"
                classes={{ root: classes.tabsRoot }}
              >
                {funds &&
                  Object.values(funds)
                    .sort(function (a, b) {
                      if (a.sortOrder) {
                        return a > b;
                      } else {
                        return moment.utc(b.createdAt).diff(moment.utc(a.createdAt));
                      }
                    })
                    .map(item => {                      
                      return (
                      <Tab
                        disableRipple
                        key={item.id}
                        value={item.id}
                        label={this.menu(item, fundId)}
                        classes={{
                          root: classes.tabRoot,
                          selected: classes.tabSelected
                        }}
                      />)}
                    )}
              </Tabs>
              <TabWrapperWithBorder />
            </Grid>
          </Grid>
        </AppBar>
        <FundAttachments
          fundId={selectedFundId}
          isOpen={isAttachmentsOpen}
          openAttachments={this.openAttachments}
          closeAttachments={this.closeAttachments}
        />
        <FundNotes
          fundId={selectedFundId}
          isOpen={isNotesOpen}
          openNotes={this.openNotes}
          closeNotes={this.closeNotes}
        />
        <FundModal
          isOpen={isNewFundModalOpen}
          isEdit={isFundModalEdit}
          onSave={onAdd}
          updateFund={this.updateFund}
          onClose={this.closeFundModal}
          fundNameList={fundNameList}
          fund={this.state.initialFundValues}
          authentication={this.props.authentication}
        />
        {/* <WhatIfModal
          isOpen = {this.state.isWhatIfModalOpen}
          scope = "fund"
          fundId = {this.state.selectedFundId}
          handleClose = {this.closeWhatIfModal}
        /> */}
      </div>
    );
  }
}

ScrollableTabButtons.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = ({
  authentication
}) => ({
  authentication
});

export default compose(
  connect(
    mapStateToProps,
    {
      updateFund,
    }
  ),
  withStyles(styles)
)(ScrollableTabButtons);

